import { createContext } from "react";
import type { UseQueryResult } from "react-query";

import type {
  MalnutritionRiskAssessment,
  PatientWeightHistory,
} from "../../types/Malnutrition";
import type Configuration from "../../types/Configuration";

export interface MalnutritionAPIContextValue {
  emrPatientID: string;
  emrHospitalID: string;
  riskAssessmentQuery: UseQueryResult<MalnutritionRiskAssessment, Error> | null;
  weightsQuery: UseQueryResult<PatientWeightHistory, Error> | null;
  // Picks the patient identifier the header shows (see getPatientIdentifier).
  configurationQuery: UseQueryResult<Configuration[], Error> | null;
}

const MalnutritionAPIContext = createContext<MalnutritionAPIContextValue>({
  emrPatientID: "",
  emrHospitalID: "",
  riskAssessmentQuery: null,
  weightsQuery: null,
  configurationQuery: null,
});

export default MalnutritionAPIContext;
